<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <label>Estabelecimento</label>
        <v-select
          label="sie_estabelecimento"
          :options="estabelecimentos"
          v-model="estabelecimentoEntity"
          @input="onLoadDayData"
          :disabled="Object.keys(this.estabelecimento).length > 0"
        >
          <template slot="no-options">Pesquise estabelecimentos pela razão social</template>
        </v-select>
      </div>
      <div class="col-md-3">
        <label>Data</label>
        <datepicker-component
          v-model="selectedDate"
          input-class="form-control"
          @change="onSelectDay"
        ></datepicker-component>
      </div>
      <div class="col-md-2">
        <label>&nbsp;</label>
        <button
          class="btn btn-primary"
          :disabled="!canMakeChanges"
          @click="onAddItemClick"
        >Adicionar registro</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <xlsx-report-component
          module="acompanhamentos"
          controller="recebimento-ovos-report"
          modal-title="Gerar relatório mensal"
          button-text="Gerar relatório mensal"
          :disabled="!selectedDate || (!estabelecimentoEntity || !estabelecimentoEntity.cod_estabelecimento) || !items.length"
        >
          <input type="hidden" name="type" value="monthly" />
          <input
            type="hidden"
            name="data"
            :value="selectedDate && selectedDate.split('/').reverse().join('-')"
          />
          <input
            type="hidden"
            name="cod_estabelecimento"
            :value="estabelecimentoEntity && estabelecimentoEntity.cod_estabelecimento"
          />
        </xlsx-report-component>
      </div>
      <div class="col-md-3">
        <xlsx-report-component
          module="acompanhamentos"
          controller="recebimento-ovos-report"
          modal-title="Gerar relatório do dia"
          button-text="Gerar relatório do dia"
          :disabled="!selectedDate || (!estabelecimentoEntity || !estabelecimentoEntity.cod_estabelecimento) || !items.length"
        >
          <input type="hidden" name="type" value="diary" />
          <input
            type="hidden"
            name="data"
            :value="selectedDate && selectedDate.split('/').reverse().join('-')"
          />
          <input
            type="hidden"
            name="cod_estabelecimento"
            :value="estabelecimentoEntity && estabelecimentoEntity.cod_estabelecimento"
          />
        </xlsx-report-component>
      </div>
    </div>
    <div class="row mt-2" v-if="boletos.length">
      <div class="col-md-12">
        <h3>Boletos do mês</h3>
      </div>
      <div class="col-md-2" v-for="(boleto, index) in boletos" :key="index">
        <p class="text text-center">
          <i class="fa fa-file-pdf-o fa-4x"></i>
          <label class="text text-center">{{ boleto.description }}</label>
          <label class="text text-center">
            Status:
            <b
              :class="{text: true, 'text-success': boleto.pago, 'text-danger': !boleto.pago}"
            >{{ boleto.pago ? 'Pago' : 'Não pago' }}</b>
          </label>
          <a :href="boleto.link" class="text text-primary text-center" target="_blank">
            <i class="fa fa-download"></i> Baixar
          </a>
        </p>
      </div>
    </div>
    <div
      class="no-data-found mt-1"
      v-if="!selectedDate || !this.estabelecimentoEntity || !this.estabelecimentoEntity.cod_estabelecimento"
    >
      <i class="fa fa-exclamation-circle"></i>
      <p>Selecione o dia e o estabelecimento</p>
    </div>
    <div class="no-data-found mt-1" v-else-if="isLoading">
      <i class="fa fa-spinner fa-pulse fa-fw"></i>
      <p>Carregando...</p>
    </div>
    <div class="no-data-found mt-1" v-else-if="items.length === 0">
      <i class="fa fa-exclamation-circle"></i>
      <p>Nenhum registro encontrado.</p>
    </div>
    <div class="mt-2" v-else>
      <div class="sida-accordion">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="{item, active: index === activeItem}"
          class="accordion-item"
          :data-index="index"
          :id="'accordion-' + index"
        >
          <h1 class="accordion-title" @click="onChangeAccordion(index)">
            {{ item.nome_produtor || ('produtor ' + (index + 1)) }}
            <button
              class="btn btn-delete"
              @click="onDeleteClick($event, index)"
              :disabled="!canMakeChanges"
            >
              <i class="fa fa-trash"></i>
            </button>
          </h1>
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group required">
                    <label>CPF/CNPJ do produtor</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.cpf_cnpj_produtor"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      @blur="onCpfCnpjBlur(item)"
                      :disabled="!canMakeChanges"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group required">
                    <label>Nome do produtor</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.nome_produtor"
                      :disabled="item.is_produtor_sidagro || !canMakeChanges"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group required">
                    <label>Espécie</label>
                    <select
                      class="form-control"
                      v-model="item.cod_especie"
                      @input="onInputEspecie($event, item)"
                      :disabled="!canMakeChanges"
                    >
                      <option value>Selecione</option>
                      <option
                        class="form-control"
                        v-for="especie of dadosAnimais.especies"
                        :key="especie.cod"
                        :value="especie.cod"
                      >{{ especie.nome }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div :class="{'form-group': true, 'required': item.cod_especie == 50}">
                    <label>Cor</label>
                    <select
                      class="form-control"
                      v-model="item.cor"
                      :disabled="!canMakeChanges || item.cod_especie != 50"
                    >
                      <option value>Selecione</option>
                      <option>Vermelho</option>
                      <option>Branco</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Nº DA CERTIFICAÇÃO SANITÁRIA DA GRANJA DE ORIGEM</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.num_certificacao_granja"
                      :disabled="!canMakeChanges"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Nº NOTA FISCAL</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.num_nota_fiscal"
                      :disabled="!canMakeChanges"
                    />
                  </div>
                </div>
              </div>
              <fieldset class="sida-fieldset m-0 my-1">
                <legend>Quantidades</legend>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group required">
                      <label>Qtd. ovos recebidos (unidades)</label>
                      <input
                        type="tel"
                        v-numeric
                        class="form-control"
                        v-model="item.qtd_ovos_recebidos"
                        :disabled="!canMakeChanges"
                      />
                    </div>
                  </div>
                </div>
                <label class="text text-left text-bold">Ovos descartados</label>
                <qtd-and-select-component
                  :value="item.descartados"
                  selectName="motivo"
                  qtdText="Quantidade descartada"
                  selectText="Selecione o motivo"
                  :options="['DEFEITOS DE CASCA', 'ALTERAÇÕES DE CLARA E GEMA', 'CONTAMINAÇÃO', 'DETERIORIZAÇÃO', 'SUJIDADES', 'MATÉRIA ESTRANHA ADERENTE', 'OUTROS']"
                  :disabled="!canMakeChanges"
                  :maxQtdSomatory="item.qtd_ovos_recebidos"
                  :showTotal="true"
                ></qtd-and-select-component>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group required">
                      <label>Qtd. ovos aproveitados</label>
                      <input
                        type="tel"
                        v-numeric
                        class="form-control"
                        v-model="item.qtd_ovos_aproveitados"
                        :disabled="!canMakeChanges"
                      />
                      <template v-if="parseInt(item.qtd_ovos_aproveitados) > parseInt(item.qtd_ovos_recebidos)">
                        <span class="text text-danger">A quantidade ovos aproveitados deve ser menor ou igual a {{ Intl.NumberFormat('pt-BR').format(item.qtd_ovos_recebidos) }} (quantidade de ovos recebidos)</span>
                        <!-- VALIDATION PURPOSE: -->
                        <div class="form-group required">
                          <input
                            type="hidden"
                            class="form-control"
                          />
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-sm-2">
        <input
          type="button"
          value="Pesquisar"
          name="Pesquisar"
          onclick="cadastro.pesquisar();"
          class="ui-button"
        />
      </div>
      <div class="col-sm-10">
        <div class="d-flex flex-row-reverse">
          <div class="d-flex justify-content-end">
            <input
              type="submit"
              value="Salvar"
              name="Salvar"
              class="btn"
              :disabled="disableSaveButton"
              @click="onSaveClick"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    estabelecimento: {
      required: false,
    },
    estabelecimentos: {
      required: true,
    },
  },
  data: () => ({
    selectedDate: null,
    isLoading: false,
    estabelecimentoEntity: null,
    requestSource: null,
    searchTimeoutId: null,
    dadosAnimais: [],
    items: [],
    boletos: [],
    deleted: [],
    // Accordion
    activeItem: null,
  }),
  watch: {
    selectedDate: function (val) {
      const selectedDate = moment(val, "DD/MM/YYYY");
      const endMonth = moment(selectedDate).endOf("month");
      const validPeriod = moment(endMonth).add(5, "days");
      const now = moment();
      if (
        !now.isSameOrBefore(validPeriod, "day") ||
        !now.isSameOrAfter(selectedDate, "day")
      ) {
        this.$toast.info("Você não pode fazer alterações na data selecionada.");
      }
    },
  },
  computed: {
    canMakeChanges() {
      let dateValid = false;
      if (this.selectedDate) {
        const selectedDate = moment(this.selectedDate, "DD/MM/YYYY");
        const endMonth = moment(selectedDate).endOf("month");
        const validPeriod = moment(endMonth).add(5, "days");
        const now = moment();
        if (
          now.isSameOrBefore(validPeriod, "day") &&
          now.isSameOrAfter(selectedDate, "day")
        ) {
          dateValid = true;
        }
      }

      return (
        dateValid &&
        this.estabelecimentoEntity &&
        this.estabelecimentoEntity.cod_estabelecimento
      );
    },
    disableSaveButton() {
      return (
        this.selectedDate === null ||
        !this.estabelecimentoEntity ||
        !this.estabelecimentoEntity.cod_estabelecimento ||
        !this.items.length
      );
    },
  },
  methods: {
    onAddItemClick() {
      const emptyItem = this.getEmptyItem();

      this.items.push(emptyItem);

      const index = this.items.length - 1;

      this.onChangeAccordion(this.items.length - 1);
    },
    onSelectDay(val) {
      this.selectedDate = val;
      this.onLoadDayData();
    },
    onLoadDayData() {
      if (
        !this.estabelecimentoEntity ||
        !this.estabelecimentoEntity.cod_estabelecimento ||
        !this.selectedDate
      ) {
        return;
      }

      this.isLoading = true;
      this.boletos = [];

      window.api
        .fetch(`/acompanhamentos/recebimento-ovos/load-day-data`, {
          params: {
            date: this.selectedDate,
            cod_pj: this.estabelecimentoEntity.cod_estabelecimento,
          },
        })
        .then((response) => {
          this.items = response.data.registers;

          if (response.data.boletos && response.data.boletos.length) {
            this.boletos = response.data.boletos;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    onInputEspecie(ev, item) {
      const selectedText = ev.target.options[ev.target.selectedIndex].innerText;
      item.nome_especie = selectedText;
    },
    onCpfCnpjBlur(item) {
      const cpfCnpj =
        item.cpf_cnpj_produtor && item.cpf_cnpj_produtor.replace(/[^0-9]/g, "");
      if (!cpfCnpj || cpfCnpj == "") {
        return;
      } else if (
        (cpfCnpj.length !== 11 && cpfCnpj.length !== 14) ||
        (cpfCnpj.length === 11 && !window.cpfValidation(cpfCnpj)) ||
        (cpfCnpj.length === 14 && !window.cnpjValidation(cpfCnpj))
      ) {
        this.$toast.error("CPF/CNPJ inválido.");
        return;
      }

      item.propriedades = [];
      item.is_produtor_sidagro = false;
      item.is_adimplente_febre_aftosa = false;

      window.api
        .fetch(`/sidagro-api/get-produtor-and-propriedades-acompanhamentos`, {
          params: {
            cpf_cnpj: cpfCnpj,
          },
        })
        .then((response) => {
          const produtor = response.data;

          item.is_produtor_sidagro = true;
          item.cpf_cnpj_produtor = produtor.cpf_cnpj;
          item.nome_produtor = produtor.nomeprodutor;
        });
    },
    onChangeAccordion(index) {
      if (this.activeItem === index) {
        this.activeItem = null;
        return;
      }

      this.activeItem = index;

      const beforeIndex = index == 0 ? index : index - 1;
      const accordionItem = document.getElementById("accordion-" + beforeIndex);
      const topPos = $(accordionItem).offset().top;
      $("html, body").animate(
        {
          scrollTop: topPos,
        },
        1000
      );
    },
    onDeleteClick(ev, index) {
      ev.preventDefault();
      ev.stopPropagation();

      const item = this.items[index];

      this.$dialog
        .confirm("Deseja realmente apagar este ítem?")
        .then((dialog) => {
          debugger;
          if (item.cod_recebimento_ovos) {
            this.deleted.push(item.cod_recebimento_ovos);
          }
          this.items.splice(index, 1);
        })
        .catch((e) => {
          console.log("Clicked on cancel", e);
        });
    },
    onSaveClick() {
      let hasError = false;
      this.$el.querySelectorAll(".form-group.required").forEach((node) => {
        const formControl = node.querySelector(".form-control");
        if (!formControl.value) {
          node.classList.add("error");
          hasError = true;
        } else {
          node.classList.remove("error");
        }
      });

      if (hasError) {
        this.$toast.error("Preencha os campos obrigatórios.");
        return;
      }

      const formData = new FormData();
      formData.set("data", JSON.stringify(this.items.map(item => {
        item.qtd_ovos_improp_consumo = item.descartados.reduce((acc, curr) => acc + (parseInt(curr.qtd) || 0), 0);
        return item;
      })));

      formData.set("deleted", JSON.stringify(this.deleted));

      window.api
        .fetch("/acompanhamentos/recebimento-ovos/salvar", {
          method: "post",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          $("#div-form").LoadingOverlay("hide", true);
          $.jAlert({
            title: "Aviso",
            content: response.message,
            theme: "green",
          });

          setTimeout(function () {
            location.reload();
          }, 1000);
        });
    },
    getEmptyItem() {
      return {
        cod_recebimento_ovos: null,
        cod_estabelecimento: this.estabelecimentoEntity.cod_estabelecimento,
        data: this.selectedDate.split("/").reverse().join("-"),
        nome_produtor: null,
        cpf_cnpj_produtor: null,
        cod_especie: '',
        nome_especie: '',
        cor: '',
        num_certificacao_granja: null,
        num_nota_fiscal: null,
        qtd_ovos_recebidos: null,
        qtd_ovos_aproveitados: null,
        qtd_ovos_improp_consumo: null,
        observations: null,
        is_produtor_sidagro: false,
        descartados: [],
      };
    },
  },
  mounted() {
    if (Object.keys(this.estabelecimento).length) {
      this.estabelecimentoEntity = {
        estabelecimento: this.estabelecimento.nome,
        sie_estabelecimento: this.estabelecimento.num_sie + ' - ' + this.estabelecimento.nome,
        cod_estabelecimento: this.estabelecimento.cod_estabelecimento,
      };
    }

    this.estabelecimentos.map(function (x){
      return x.sie_estabelecimento = x.num_sie + ' - ' + x.estabelecimento;
    });
    
    window.api
        .fetch(
          "/acompanhamentos/recebimento-ovos/load-form-data",
          {
            method: "get",
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((response) => {
          this.dadosAnimais = response.data;
          console.log(this.dadosAnimais);
        })
        .catch((error) => {
          this.$toast.error(
              "Erro ao buscar dados."
            );
        });
  },
};
</script>
<style lang="scss" scoped>
.sida-accordion .item .content {
  background: #f3f3f3;
}

.container {
  .no-data-found {
    padding: 100px 16px;
  }
}
</style>
